import React from 'react';
import styled from 'styled-components';
import * as CONSTANTS from '../constants';
import { ModalContext } from '../context/modal';

const PaginationTrigger = styled.button`
  border-radius: 3px;
  font-size: ${CONSTANTS.ctaText};
  font-weight: 200;
  text-align: center;
  display: block;
  padding: 8px 30px;
  color:  ${props => (props.darkMode === true) ? `${CONSTANTS.white}` : `${CONSTANTS.white}`};
  background-color: ${props => (props.darkMode === true) ? `#1a1a1a` : `${CONSTANTS.darkGray}`};
  margin: 30px auto 0 auto;
  width: 100%;
  width: calc(100% - 60px);
  max-width: 1020px;
  padding: 0 30px;
  line-height: 50px;
  margin-bottom: 30px;
  cursor: pointer;

  &:hover {
    background-color: ${props => (props.darkMode === true) ? `${CONSTANTS.darkModeCtaHoverBackground}` : `${CONSTANTS.fakeCtaOpacity}`};
  }
`;

export default class PaginationButton extends React.Component {
  constructor(props) {
    super(props);
  }

  render () {
    return (
      <PaginationTrigger
        isVisible={this.props.isVisible}
        darkMode={this.context.darkMode}
        dangerouslySetInnerHTML={{__html: this.props.text}}
      />
    );
  }
}

PaginationButton.contextType = ModalContext;
